import $ from 'jquery';
import City from 'blocks/city/city';
import Numbered from 'input.numbered';
import Animation from 'modules/animation/animation';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaB2bModemOrder',
			dom: {
				form: '#yotaB2bModemOrderForm',
				phone: '#yotaB2bModemOrderPhone',
				city: '#yotaB2bModemOrderCity',
				citySearch: '.js-city',
				type: '#yotaB2bModemOrderType',
				subtype: '#yotaB2bModemOrderSubype',
				name: '#yotaB2bModemOrderName',
				fio: '#yotaB2bModemOrderFio',
				numbered: '#yotaB2bModemOrderNumbered',
				mail: '#yotaB2bModemOrderMail'
			},
			classes: {
				state: {
					send: 'b-b2b-modem-order_state_send'
				},
				field: {
					state: {
						error: 'b-field_state_error'
					}
				}
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.sended = false;
		this.$el = $(this.options.el);
		this.$window = $(window);
		return this;
	}

	getDom() {
		const self = this;
		self.$form = $(self.options.dom.form);

		self.$phone = $(self.options.dom.phone);
		self.$city = $(self.options.dom.city);
		self.$citySearch = self.$el.find(self.options.dom.citySearch);
		self.$type = $(self.options.dom.type);
		self.$subtype = $(self.options.dom.subtype);
		self.$name = $(self.options.dom.name);
		self.$fio = $(self.options.dom.fio);
		self.$numbered = $(self.options.dom.numbered);
		self.$mail = $(self.options.dom.mail);

		self.$field = self.$name
			.add(self.$fio)
			.add(self.$numbered)
			.add(self.$mail)
			.add(self.$citySearch);
		return self;
	}

	validate() {
		const self = this;
		let numbered = self.numbered.validate();
		self.$phone.val(self.$numbered.val().replace(/[^\d]/gi, ''));
		if (numbered <= 0) {
			self.$numbered.parent().addClass(self.options.classes.field.state.error);
			$(() => new Animation({el: self.$numbered.parent()}).play('shake'));
		}

		const name = self.$name.val().trim();
		if (name == '' || name.length > 128) {
			self.$name.parent().addClass(self.options.classes.field.state.error);
			$(() => new Animation({el: self.$name.parent()}).play('shake'));
			numbered = 0;
		}

		const city = self.$city.val().trim();
		if (city == '') {
			self.$citySearch.addClass(self.options.classes.field.state.error);
			$(() => new Animation({el: self.$citySearch.parent()}).play('shake'));
			numbered = 0;
		}

		const fio = self.$fio.val().trim();
		if (fio == '' || fio.length > 128) {
			self.$fio.parent().addClass(self.options.classes.field.state.error);
			$(() => new Animation({el: self.$fio.parent()}).play('shake'));
			numbered = 0;
		}

		const mail = self.$mail.val().trim();
		if (mail == '' || mail.length > 128 || !/^(.)+[\@](.)+[\.](.)+/.test(mail)) {
			self.$mail.parent().addClass(self.options.classes.field.state.error);
			$(() => new Animation({el: self.$mail.parent()}).play('shake'));
			numbered = 0;
		}

		return numbered;
	}

	onFocus(event) {
		const $filed = $(event.currentTarget);
		$filed.parent().removeClass(this.options.classes.field.state.error);
	}

	onSubmit(event) {
		/* eslint no-alert: 0 */
		const self = this;
		event.preventDefault();
		if (!self.sended) {
			if (self.validate() > 0) {
				self.sended = true;
				$.ajax({
					url: self.$form.attr('action'),
					type: self.$form.attr('method'),
					data: self.$form.serialize(),
					dataType: 'json',
					success: function (json) {
						if (json && json.success) {
							self.$el.addClass(self.options.classes.state.send);
						} else {
							alert(json.error || self.$form.data('error'));
						}
						self.sended = false;
					},
					error: function () {
						alert(self.$form.data('error'));
						self.sended = false;
					}
				});
			}
		}

		return self;
	}

	onCitySet(data) {
		this.$city.val(data.code);
		this.$citySearch.removeClass(this.options.classes.field.state.error);
	}

	onDataSet(event, data) {
		this.$type.html(data.type);
		this.$subtype.html(data.subtype);
	}

	render() {
		const self = this;
		if (self.$el.length) {
			self.getDom();
			self.$form.on('submit', self.onSubmit.bind(self));
			self.numbered = new Numbered(self.$numbered);

			self.city = new City({
				el: this.$citySearch,
				callback: {
					set: self.onCitySet.bind(self)
				}
			}).render();


			self.$field.on('change input focusin', self.onFocus.bind(self));
			self.$window.on('yota.b2b.modem.change', self.onDataSet.bind(self));
		}
		return self;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/b2b-modem-order/b2b-modem-order.js